/*
 * <cart-drawer>: the right-hand cart panel from sections/cart-drawer.liquid.
 * Opened by product-form.js after an add to cart (the header cart icon is a
 * plain link to the cart page); closes on [data-cart-close], Escape and a
 * backdrop click. Quantity changes, re-rendering and Checkout blocking come
 * from assets/cart-lines.js, which the section loads first.
 * Public API for other scripts: open(), close(), render(sectionHtml).
 */
if (!customElements.get('cart-drawer')) {
  customElements.define(
    'cart-drawer',
    class CartDrawer extends window.AsansaraCartLines {
      connectedCallback() {
        super.connectedCallback();
        this.drawer = new window.AsansaraDrawer(this.dialog, '[data-cart-close]');
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        this.drawer?.destroy();
      }

      get dialog() {
        return this.querySelector('dialog');
      }

      open(opener) { this.drawer.open(opener); }
      close() { this.drawer.close(); }

      // Markup from another script, e.g. the /cart/add.js response. If changes are pending it
      // may predate their result, so the queue re-reads the section after them instead.
      render(html) {
        const fresh = this.parse(html);
        if (fresh && !this.blocked) this.swap(fresh);
        else this.enqueue(() => null);
      }

      parse(html) {
        const fresh = super.parse(html);
        return fresh?.querySelector('dialog > *') ? fresh : null;
      }

      // Swaps only the panel's content: the dialog element and its open state survive, so an
      // open drawer never re-animates and a drawer about to open animates exactly once.
      replace(fresh) {
        this.dialog.firstElementChild.replaceChildren(...fresh.querySelector('dialog > *').childNodes);
      }

      restoreFocus(target) {
        if (this.dialog.open) (target || this.querySelector('[data-cart-close]'))?.focus({ preventScroll: true });
      }
    },
  );
}
